import { AuditLog, UserRole } from '../types';

// Service de logs d'audit pour tracer toutes les actions
const mockAuditLogs: AuditLog[] = [
  {
    id: 'audit-1',
    userId: '3',
    userRole: 'responsable_equipe',
    action: 'UPDATE_PROFILE',
    entityType: 'user',
    entityId: '3',
    changes: { firstName: 'Pierre', lastName: 'Moreau' },
    timestamp: '2024-12-15T14:30:00Z',
    ipAddress: '192.168.1.100',
    description: 'Mise à jour du profil utilisateur'
  },
  {
    id: 'audit-2',
    userId: '2',
    userRole: 'responsable_bureau',
    action: 'CREATE_USER',
    entityType: 'user',
    entityId: '5',
    changes: { email: 'nouveau@herminette.fr', role: 'stagiaire' },
    timestamp: '2024-12-15T15:00:00Z',
    ipAddress: '192.168.1.101',
    description: 'Création d\'un nouvel utilisateur stagiaire'
  },
  {
    id: 'audit-3',
    userId: '1',
    userRole: 'admin',
    action: 'UPDATE_TEAM',
    entityType: 'team',
    entityId: 'team-1',
    changes: { name: 'Équipe Alpha', members: ['3', '4'] },
    timestamp: '2024-12-15T08:15:00Z',
    ipAddress: '192.168.1.102',
    description: 'Mise à jour de l\'équipe Alpha'
  }
];

class AuditService {
  async getAuditLogs(filters?: {
    userId?: string;
    action?: string;
    entityType?: string;
    startDate?: string;
    endDate?: string;
  }): Promise<AuditLog[]> {
    await new Promise(resolve => setTimeout(resolve, 300));
    
    let filtered = [...mockAuditLogs];
    
    if (filters?.userId) {
      filtered = filtered.filter(log => log.userId === filters.userId);
    }
    
    if (filters?.action) {
      filtered = filtered.filter(log => log.action === filters.action);
    }
    
    if (filters?.entityType) {
      filtered = filtered.filter(log => log.entityType === filters.entityType);
    }
    
    return filtered.sort((a, b) => 
      new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
    );
  }

  async logAction(
    userId: string,
    userRole: UserRole,
    action: string,
    entityType: 'user' | 'team',
    entityId: string,
    changes?: Record<string, any>,
    description?: string
  ): Promise<void> {
    const newLog: AuditLog = {
      id: `audit-${Date.now()}`,
      userId,
      userRole,
      action,
      entityType,
      entityId,
      changes,
      timestamp: new Date().toISOString(),
      ipAddress: '192.168.1.100', // Simulé
      description: description || `Action ${action} sur ${entityType} ${entityId}`
    };
    
    mockAuditLogs.unshift(newLog);
  }

  getActionLabel(action: string): string {
    const labels: Record<string, string> = {
      'CREATE_USER': 'Création utilisateur',
      'UPDATE_USER': 'Modification utilisateur',
      'UPDATE_PROFILE': 'Mise à jour profil',
      'CREATE_TEAM': 'Création équipe',
      'UPDATE_TEAM': 'Modification équipe',
      'LOGIN': 'Connexion',
      'LOGOUT': 'Déconnexion'
    };
    return labels[action] || action;
  }

  getRoleLabel(role: UserRole): string {
    const labels: Record<UserRole, string> = {
      admin: 'Administrateur',
      responsable_bureau: 'Responsable bureau',
      responsable_depot: 'Responsable dépôt',
      responsable_equipe: 'Responsable équipe',
      charpentier: 'Charpentier',
      stagiaire: 'Stagiaire'
    };
    return labels[role];
  }
}

export const auditService = new AuditService();